// extracted by mini-css-extract-plugin
export default {"textWrapper":"FMI2coNPuKXCGpRtxe8B","subTitle":"jbMX8H7567Da8DgnhrBT","disabled":"u914ReaNDjv82FM0qGBb"};